import apiIbge from './apiIbge';

const Ibge = {

    getCnaes: async () => {
        try {
            const res = await apiIbge.get('/cnae/classes');
            return res
        } catch (error) {
            return error
        }
    }
}

export default Ibge;